const doc = [({"ja":({"adminLabelCompanyInvoice":({"uniqueId":"請求書番号", "createdDate":"作成日", "price":"料金"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;